import getConfig from '../config/env';

class Settings {
	constructor(config) {
		this.config = config;
	}

	getConfig() {
		return this.config;
	}

	getApiUrl(action) {
		return `${this.config.api}/${action}`;
	}

	enlightenMenuUrl(menu) {
		return `${this.config.enlighten_url}/${menu}`;
	}


  einCoreUrl(url) {
    return `${this.config.ein_core_url}/api/v1/${url}`;
  }

	solargraf(url) {
		return `${this.config.solargraf_url}/${url}`;
	}

	solargrafApiUrl(url) {
		return `${this.config.solargraf_api_url}/${url}`;
	}

	digiCoreUrl(url) {
		return `${this.config.digital_core_url}/api/v1/${url}`;
	}

	getDrsUrl(url) {
    return `${this.config.drs_url}/api/v1/${url}`;
  }
	
	drsUiUrl(url) {
    return `${this.config.drs_ui_url}/${url}`;
  }

  getEnlightenApiUrl(url) {
    return `${this.config.enlighten_api_url}/${url}`;
  }

  getEnphaseUiUrl(url) {
    return `${this.config.enphase_ui_url}/${url}`;
  }
}

export default new Settings(getConfig());
